import {Auth0Provider} from "@auth0/auth0-react"
import React from "react"
import ReactDOM from "react-dom/client"
import {createBrowserRouter, createRoutesFromElements, Route, RouterProvider} from "react-router-dom"

import App from "@/components/App"
import {AUTH0_AUDIENCE, AUTH0_CLIENT_ID, AUTH0_DOMAIN} from "@/constants"

import "./globals.css"

const baseName = window.location.pathname

const router = createBrowserRouter(createRoutesFromElements(<Route path="/" element={<App />}></Route>), {basename: baseName})

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
    //<React.StrictMode>
    <Auth0Provider
        domain={AUTH0_DOMAIN}
        clientId={AUTH0_CLIENT_ID}
        authorizationParams={{
            redirect_uri: window.location.origin,
            audience: AUTH0_AUDIENCE,
        }}
    >
        <RouterProvider router={router} />
    </Auth0Provider>,
    //</React.StrictMode>,
)
